module.exports = __webpack_public_path__ + "static/media/pause.c2a3a6d1.png";